/* global document, window */
import '../../../styles/next/blocks/_post-grid.scss';

// acf/next-post-grid: a post's featured video plays while its card is hovered or focused, and pauses after.
// Nothing plays for visitors who prefer reduced motion; they see the poster image.
const init = () => {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return;
  }

  document.querySelectorAll('.aqn-post-card__video').forEach((video) => {
    const card = video.closest('.aqn-post-card');
    // play() rejects when a pause interrupts it or the browser blocks it; the poster stays, which is fine.
    const play = () => video.play().catch(() => undefined);
    const pause = () => video.pause();

    card.addEventListener('pointerenter', play);
    card.addEventListener('pointerleave', pause);
    card.addEventListener('focusin', play);
    card.addEventListener('focusout', pause);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
